import Component from 'inferno-component';
import { connect } from 'inferno-redux';

import { getCognitoUser, verifyUserLoggedIn } from '../redux/auth';

import HeaderNav from './HeaderNav';
import FooterNav from './FooterNav';
import LoadingSpinner from './LoadingSpinner';

function mapStateToProps(state) {
  return {
    user: state.auth.userInformation,
    userIsLoggedIn: state.auth.userIsLoggedIn,
  };
}

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  componentDidMount() {
    const { getCognitoUser, verifyUserLoggedIn } = this.props;
    verifyUserLoggedIn()
      .then(() => {
        getCognitoUser();
      })
      .catch(err => {
        this.setState({ errorMessage: err });
      });
  }

  render() {
    const {
      footerMode,
      headerSideContent,
      hideSmallSearchBar,
      isLoading = false,
      navMode,
      noScroll,
      searchResults,
      searchTerm,
      showLargeSearchBar,
      title,
      user,
      userIsLoggedIn,
    } = this.props;

    const noScrollClass = noScroll ? 'no-scroll' : '';
    return (
      <div className={`page ${noScrollClass}`}>
        <div className="page__content">
          {isLoading && <LoadingSpinner />}
          <HeaderNav
            hideSmallSearchBar={hideSmallSearchBar}
            mode={navMode}
            sideContent={headerSideContent}
            searchResults={searchResults}
            searchTerm={searchTerm || ''}
            showLargeSearchBar={showLargeSearchBar || false}
            pageTitle={title}
            user={user}
            userIsLoggedIn={userIsLoggedIn}
          />
          {this.props.children}
        </div>
        <FooterNav mode={footerMode || false} />
      </div>
    );
  }
}

export default connect(mapStateToProps, { getCognitoUser, verifyUserLoggedIn })(
  Page
);



// WEBPACK FOOTER //
// ./src/components/Page.js